const API = {
  CUSTOMERS: "/web/v3/customer/main",
};

export default API;
